import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {Route, Switch, useHistory, useLocation} from "react-router-dom";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import ContentBlogListView from "./list";
import ContentBlogInformationView from "./single";


const ContentBlogs = () => {
    const location = useLocation();
    const history = useHistory();

    /**
     * Listens to the changes in location.pathname and with each change:
     * if the url is the same as content.base, then changes it to the blogs.list.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.content.blogs.base, exact: true})) {
            history.replace(routes.content.blogs.list);
        }
    }, [history, location.pathname])

    return (
        <Switch>
            <Route path={[routes.content.blogs.base, routes.content.blogs.list]} exact>
                <ContentBlogListView/>
            </Route>
            <Route path={[routes.content.blogs.single]} exact>
                <ContentBlogInformationView/>
            </Route>
        </Switch>
    );
};

export default ContentBlogs;
